import { RefreshCw } from "lucide-react"
import { useNeueFassung } from "@/lib/neueFassung"

/**
 * „Es gibt eine neue Fassung" — oben auf jeder Seite, nicht wegklickbar.
 *
 * 🔴 Anlass 04.09.2026: dreimal wurde ein Fehler gemeldet, der laengst behoben
 * war. Der Tab stand seit dem Vorabend offen und lief mit der alten Fassung
 * weiter; die Mail-Liste zeigte einen Stand von 20:33 des Vortages, waehrend im
 * Postfach schon sieben neue Mails lagen. Fuer die Bedienende sah das aus wie
 * „mails verschwinden".
 *
 * Deshalb ist dieses Banner nicht wegklickbar und nennt beide Folgen — der
 * veraltete Stand ist nicht nur ein fehlender Fix, sondern auch eine Liste, die
 * nichts Neues mehr zeigt.
 *
 * Kein automatisches Neuladen: daran haengen offene Entwuerfe.
 */
export function NeueFassungBanner() {
  const neu = useNeueFassung()
  if (!neu) return null

  return (
    <div
      role="status"
      style={{
        position: "sticky", top: 0, zIndex: 60,
        // Mittig statt rechts (Paul 15.10.2026): rechts oben liegen „Problem
        // melden" & Co. darüber, der Knopf war dort kaum zu treffen.
        display: "flex", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: 10,
        padding: "8px 16px", fontSize: 13, fontWeight: 500, textAlign: "center",
        background: "#eef2ff", color: "#3730a3",
        borderBottom: "1px solid #c7d2fe",
      }}
    >
      <RefreshCw size={15} aria-hidden />
      <span>
        Es gibt eine neue Fassung des Portals. Diese Seite läuft noch mit der alten —
        sie zeigt keine neuen E-Mails mehr an.
      </span>
      <button
        className="pp-btn pp-btn-sm"
        style={{ fontWeight: 600 }}
        onClick={() => window.location.reload()}
      >
        Jetzt neu laden
      </button>
    </div>
  )
}
